import React from 'react';
import { Box, Typography } from '@mui/material';
import Hai from './Hai';

const styles = {
  area: {
    padding: '10px',
    border: '2px solid #ccc',
    borderRadius: '5px',
    minHeight: '70px', // 他のエリアと高さを合わせる
    display: 'grid',
    // 可変個の牌をレスポンシブに表示するためのグリッド設定
    gridTemplateColumns: 'repeat(auto-fill, minmax(40px, 1fr))',
    gap: '8px',
    alignContent: 'flex-start', // 牌が少ない場合に上寄せにする
  },
};

const AgarihaiResult = ({ agarihais }) => {
  if (!agarihais || agarihais.length === 0) {
    return <Typography sx={{ mt: 4 }}>アガリ牌はありません。</Typography>;
  }

  return (
    <>
      <Typography variant="subtitle2" gutterBottom>アガリ牌</Typography>
      <Box sx={styles.area}>
        {agarihais.map((haiId) => <Box key={haiId} sx={{ minWidth: 0 }}><Hai haiId={haiId} /></Box>)}
      </Box>
    </>
  );
};

export default AgarihaiResult;